<div class="bg-[#232323] text-white w-full flex flex-col overflow-hidden">

  <!-- Banner / Carrossel (full-width, proporção 4:1 — escala sem cortar) -->
  <div class="relative w-full aspect-[4/1] max-h-[484px] min-h-[160px] overflow-hidden bg-zinc-900">
    @if (banners.length > 0) {
      @for (banner of banners; track banner.id; let i = $index) {
        <div class="absolute inset-0 transition-opacity duration-700 ease-in-out"
             [class.opacity-100]="i === bannerAtualIndex"
             [class.opacity-0]="i !== bannerAtualIndex"
             [class.pointer-events-none]="i !== bannerAtualIndex">
          <img [src]="banner.imagemUrl" [alt]="banner.nome"
               class="absolute inset-0 h-full w-full object-cover z-0"
               [class.cursor-pointer]="bannerClicavel(banner)"
               (click)="abrirLinkBanner(banner)" />
        </div>
      }

      <!-- Indicadores (acima do fade) -->
      @if (banners.length > 1) {
        <div class="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-30">
          @for (banner of banners; track banner.id; let i = $index) {
            <button type="button"
                    class="h-2.5 rounded-full transition-all"
                    [ngClass]="i === bannerAtualIndex ? 'bg-white w-8' : 'w-2.5 bg-white/40'"
                    (click)="irParaBanner(i)"
                    [attr.aria-label]="'Ir para banner ' + (i + 1)"></button>
          }
        </div>
      }
    } @else {
      <!-- Sem banners cadastrados: imagem padrão -->
      <img [src]="capa" alt="" class="absolute inset-0 h-full w-full object-cover z-0">
    }

  </div>

  <!-- Cards de Performance por Perfil -->
  <h2 class="text-xl font-bold px-4 md:px-16 pb-6 mt-6">{{ performanceTitle }}</h2>

  <!-- ==================== CARDS ADM_IMOBILIARIA ==================== -->
  <ng-container *ngIf="isAdmImobiliaria">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 px-4 md:px-16 py-2">
      <!-- Card: Pontuação Total da Equipe -->
      <div class="perf-card cursor-pointer hover:border-[#E4811E]/50 transition-all" (click)="navegarParaGestao()">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-[#E4811E]/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-[#E4811E]">stars</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Pontuação Total da Equipe</h3>
            <p class="perf-value font-semibold">{{ homeAdmImobiliaria?.pontuacaoTotalEquipe | number }}</p>
          </div>
        </div>
      </div>

      <!-- Card: Quantidade de Usuários -->
      <div class="perf-card">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-blue-500">group</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Colaboradores na Equipe</h3>
            <p class="perf-value font-semibold">{{ homeAdmImobiliaria?.quantidadeUsuarios | number }}</p>
          </div>
        </div>
      </div>

      <!-- Card: Engajamento Médio -->
      <div class="perf-card cursor-pointer hover:border-[#E4811E]/50 transition-all" (click)="navegarParaGestao()">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-green-500">insights</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Engajamento Médio</h3>
            <p class="perf-value font-semibold">{{ homeAdmImobiliaria?.engajamentoMedioEquipe | number:'1.1-1' }}%</p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ==================== CARDS USUARIO_IMOBILIARIA (Plano 1) ==================== -->
  <ng-container *ngIf="isUsuarioPlano1 && homeUsuarioPlano1">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 px-4 md:px-16 py-2">
      <!-- Card: Tempo Assistido -->
      <div class="perf-card">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-[#E4811E]/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-[#E4811E]">schedule</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Tempo Assistido</h3>
            <p class="perf-value font-semibold">{{ formatTempoAssistido() }}</p>
          </div>
        </div>
      </div>

      <!-- Card: Certificados Conquistados -->
      <div class="perf-card cursor-pointer hover:border-purple-500/50 transition-all" (click)="navegarParaCertificados()">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-purple-500/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-purple-500">workspace_premium</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Certificados</h3>
            <p class="perf-value font-semibold">{{ homeUsuarioPlano1.certificadosConquistados | number }}</p>
          </div>
        </div>
      </div>

      <!-- Card: Badges (plano básico vê Badges, não Ranking) -->
      <div class="perf-card cursor-pointer hover:border-green-500/50 transition-all" (click)="navegarParaBadges()">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-green-500">military_tech</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Conquistas</h3>
            <div class="flex items-baseline gap-2">
              <p class="perf-value font-semibold">{{ homeUsuarioPlano1.badgesConquistadas?.conquistadas ?? 0 }}</p>
              <span class="text-sm text-white/50">/ {{ homeUsuarioPlano1.badgesConquistadas?.total ?? 0 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ==================== CARDS USUARIO_IMOBILIARIA (Plano 2+) ==================== -->
  <ng-container *ngIf="isUsuarioPlano2Plus && homeUsuarioPlano2">
    <div class="grid grid-cols-2 md:grid-cols-4 gap-4 px-4 md:px-16 py-2">
      <!-- Card: Tempo Assistido -->
      <div class="perf-card">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-[#E4811E]/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-[#E4811E]">schedule</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Tempo Assistido</h3>
            <p class="perf-value font-semibold">{{ formatTempoAssistido() }}</p>
          </div>
        </div>
      </div>

      <!-- Card: Certificados Conquistados -->
      <div class="perf-card cursor-pointer hover:border-purple-500/50 transition-all" (click)="navegarParaCertificados()">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-purple-500/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-purple-500">workspace_premium</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Certificados</h3>
            <p class="perf-value font-semibold">{{ homeUsuarioPlano2.certificadosConquistados | number }}</p>
          </div>
        </div>
      </div>

      <!-- Card: Badges/Conquistas -->
      <div class="perf-card cursor-pointer hover:border-green-500/50 transition-all" (click)="navegarParaBadges()">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-green-500">military_tech</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Conquistas</h3>
            <div class="flex items-baseline gap-2">
              <p class="perf-value font-semibold">{{ homeUsuarioPlano2.badgesConquistadas.conquistadas }}</p>
              <span class="text-sm text-white/50">/ {{ homeUsuarioPlano2.badgesConquistadas.total }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Card: Ranking Imobiliária -->
      <div class="perf-card cursor-pointer hover:border-yellow-500/50 transition-all" (click)="navegarParaRanking()">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-yellow-500/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-yellow-500">emoji_events</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Ranking da Imobiliária</h3>
            <div class="flex items-baseline gap-2">
              <p class="perf-value font-semibold">#{{ homeUsuarioPlano2.rankingImobiliaria.posicao }}</p>
              <span class="text-sm text-white/50">de {{ homeUsuarioPlano2.rankingImobiliaria.totalParticipantes }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ==================== CARDS ADM_SISTEMA ==================== -->
  <ng-container *ngIf="isAdmSistema && homeAdmSistema">
    <div class="grid grid-cols-2 md:grid-cols-4 gap-4 px-4 md:px-16 py-2">
      <!-- Card: Imobiliárias Ativas -->
      <div class="perf-card">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-[#E4811E]/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-[#E4811E]">business</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Imobiliárias Ativas</h3>
            <p class="perf-value font-semibold">{{ homeAdmSistema.quantidadeImobiliariasAtivas | number }}</p>
          </div>
        </div>
      </div>

      <!-- Card: Usuários Ativos -->
      <div class="perf-card">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-blue-500">group</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Usuários Ativos</h3>
            <p class="perf-value font-semibold">{{ homeAdmSistema.quantidadeUsuariosAtivos | number }}</p>
          </div>
        </div>
      </div>

      <!-- Card: Crescimento Mensal -->
      <div class="perf-card">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0">
            <mat-icon [ngClass]="getCrescimentoColorClass(homeAdmSistema.crescimentoMensal.variacao)">
              {{ getCrescimentoIcon(homeAdmSistema.crescimentoMensal.variacao) }}
            </mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Crescimento Mensal</h3>
            <p class="perf-value font-semibold" [ngClass]="getCrescimentoColorClass(homeAdmSistema.crescimentoMensal.variacao)">
              {{ homeAdmSistema.crescimentoMensal.variacao === 'positivo' ? '+' : '' }}{{ homeAdmSistema.crescimentoMensal.percentual | number:'1.1-1' }}%
            </p>
          </div>
        </div>
      </div>

      <!-- Card: Parceiros Ativos -->
      <div class="perf-card">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-purple-500/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-purple-500">handshake</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Parceiros Ativos</h3>
            <p class="perf-value font-semibold">{{ homeAdmSistema.parceirosAtivos | number }}</p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- ==================== CARDS PARCEIRO ==================== -->
  <ng-container *ngIf="isParceiro && homeParceiro">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 px-4 md:px-16 py-2">
      <!-- Card: Cupons Utilizados -->
      <div class="perf-card">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-[#E4811E]/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-[#E4811E]">confirmation_number</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Cupons Utilizados</h3>
            <p class="perf-value font-semibold">{{ homeParceiro.quantidadeCuponsUtilizados | number }}</p>
          </div>
        </div>
      </div>

      <!-- Card: Imobiliárias Ativas (com cupom) -->
      <div class="perf-card">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center flex-shrink-0">
            <mat-icon class="text-blue-500">business</mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Imobiliárias Ativas</h3>
            <p class="perf-value font-semibold">{{ homeParceiro.imobiliariasAtivasComCupom | number }}</p>
            <p class="text-xs text-white/40">Usando seu cupom</p>
          </div>
        </div>
      </div>

      <!-- Card: Crescimento Mensal -->
      <div class="perf-card">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0">
            <mat-icon [ngClass]="getCrescimentoColorClass(homeParceiro.crescimentoMensal.variacao)">
              {{ getCrescimentoIcon(homeParceiro.crescimentoMensal.variacao) }}
            </mat-icon>
          </div>
          <div>
            <h3 class="perf-title">Crescimento Mensal</h3>
            <p class="perf-value font-semibold" [ngClass]="getCrescimentoColorClass(homeParceiro.crescimentoMensal.variacao)">
              {{ homeParceiro.crescimentoMensal.variacao === 'positivo' ? '+' : '' }}{{ homeParceiro.crescimentoMensal.percentual | number:'1.1-1' }}%
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Loading Skeleton -->
  <ng-container *ngIf="loading">
    <div class="grid grid-cols-2 md:grid-cols-4 gap-4 px-4 md:px-16 py-2">
      <div *ngFor="let _ of [1,2,3,4]" class="perf-card animate-pulse">
        <div class="flex items-center gap-4 w-full">
          <div class="w-12 h-12 rounded-full bg-zinc-700"></div>
          <div class="flex-1">
            <div class="h-4 bg-zinc-700 rounded w-24 mb-2"></div>
            <div class="h-6 bg-zinc-700 rounded w-16"></div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Continue assistindo -->
  <div class="pl-4 md:pl-16 pt-8 pr-4 md:pr-8" *ngIf="this.continuar.length > 0">
    <h2 class="text-xl font-bold mb-4">Continue assistindo</h2>

    <div class="relative">
      <button class="carousel-nav left-0" *ngIf="overflows[0]" (click)="scrollCarousel(0,'left')">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button class="carousel-nav right-0" *ngIf="overflows[0]" (click)="scrollCarousel(0,'right')">
        <mat-icon>chevron_right</mat-icon>
      </button>

      <div #carouselRef class="carousel-row flex flex-nowrap gap-4 overflow-x-auto scroll-smooth pb-4 hide-scrollbar"
           (scroll)="computeOverflowFor(0)">
        <div *ngFor="let m of continuar"
             class="mod-card relative hover-card cursor-pointer"
             (click)="openEmAndamento(m)">

          <img [src]="m.imagemUrl" class="w-full h-full object-cover" [alt]="m.nome" (load)="computeOverflowFor(0)"/>

          <!-- círculo de progresso -->
          <div class="progress-badge">
            <svg class="-rotate-90" [attr.viewBox]="'0 0 ' + ring.size + ' ' + ring.size"
                 [style.width.px]="ring.size" [style.height.px]="ring.size">
              <circle [attr.cx]="ring.size/2" [attr.cy]="ring.size/2" [attr.r]="ring.r"
                      [attr.stroke-width]="ring.sw" stroke="rgba(255,255,255,0.25)" fill="transparent"/>
              <circle [attr.cx]="ring.size/2" [attr.cy]="ring.size/2" [attr.r]="ring.r"
                      [attr.stroke-width]="ring.sw" stroke-linecap="round" fill="transparent"
                      [attr.stroke]="getProgressColor(m.progresso)"
                      [attr.stroke-dasharray]="ring.c"
                      [attr.stroke-dashoffset]="dashOffset(m.progresso)"
                      style="transition: stroke-dashoffset .3s ease, stroke .3s ease"/>
            </svg>
            <span class="progress-text">{{ m.progresso }}%</span>
          </div>

          <div class="absolute inset-x-0 bottom-0 p-3">
            <p class="text-xl font-bold text-white whitespace-normal break-words leading-snug
                      drop-shadow-[0_2px_8px_rgba(0,0,0,0.7)]">
              {{ m.nome }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>